import { MainLoadingSkeleton } from 'components/Directories/Styled'
import ListingCard from './ListingCard'

const ListingCardWithSkeleton = ({ index, listing, isLoading }) => {
  if (isLoading) {
    return (
      <MainLoadingSkeleton
        mb='16px'
        minWidth={{ _: '335px', tablet: '115px', desktop: '845px' }}
        minHeight={{ _: '390px', tablet: '315px', desktop: '210px' }}
      />
    )
  }
  return (
    <ListingCard
      listing={listing}
      key={index}
      maxWidth={{ _: '335px', tablet: '115px', desktop: '845px' }}
    />
  )
}

export default ListingCardWithSkeleton
